export const setupScrollEndListener = (container: HTMLDivElement, onComplete: () => void) => {
	if ('onscrollend' in window) {
		const handleScrollEnd = () => {
			container.removeEventListener('scrollend', handleScrollEnd);
			onComplete();
		};
		container.addEventListener('scrollend', handleScrollEnd, { passive: true });
		return;
	}

	let scrollTimeout: ReturnType<typeof setTimeout> | undefined;
	const handleScroll = () => {
		if (scrollTimeout) clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			container.removeEventListener('scroll', handleScroll);
			onComplete();
		}, 150);
	};
	container.addEventListener('scroll', handleScroll, { passive: true });
};

export const setupScrollObservers = (container: HTMLDivElement, updateScrollState: () => void): (() => void) => {
	requestAnimationFrame(updateScrollState);

	const mutationObserver = new MutationObserver(() => {
		setTimeout(updateScrollState, 50);
	});
	mutationObserver.observe(container, { childList: true, subtree: true });

	const resizeObserver = new ResizeObserver(() => {
		setTimeout(updateScrollState, 100);
	});
	resizeObserver.observe(container);

	let rafId: number | null = null;
	const handleScroll = () => {
		if (rafId !== null) return;
		rafId = requestAnimationFrame(() => {
			rafId = null;
			updateScrollState();
		});
	};
	container.addEventListener('scroll', handleScroll, { passive: true });

	const handleResize = () => {
		setTimeout(updateScrollState, 100);
	};
	window.addEventListener('resize', handleResize, { passive: true });

	return () => {
		mutationObserver.disconnect();
		resizeObserver.disconnect();
		container.removeEventListener('scroll', handleScroll);
		window.removeEventListener('resize', handleResize);
		if (rafId !== null) cancelAnimationFrame(rafId);
	};
};
